<div class="banner" [style.backgroundColor]="banner?.backgroundColor" [style.display]="isOpen? 'flex' : 'none'">
  <div [innerHTML]="banner.content[this.langauge]">
  </div>

  <mat-icon (click)="$event.stopPropagation();close()">close</mat-icon>
</div>
